import { type ResourceBundle } from "../core/language";

const bundles: ResourceBundle[] = [];
bundles.push({
    lang: 'de',
    namespace: 'common',
    resources: {
        "charsLeft": "{{rest}} Zeichen verbleibend",
        "minLength": "Mindestlänge: {{min}} Zeichen",
        "maxLength": "Maximale Länge: {{max}} Zeichen",
        "action": {
            "ok": "OK",
            "cancel": "Abbrechen",
            "apply": "Anwenden",
            "delete": "Löschen",
            "remove": "Entfernen",
            "stop": "Stop",
            "append": "Anfügen",
            "add": "Hinzufügen",
            "selectDate": "Datum auswählen"
        },
        "alert": {
            "notice": "Notiz",
            "notify": "Hinweis",
            "error": "Fehler",
            "warning": "Warnung",
            "success": "Erfolgreich"
        },
        "error": {
            "request": {
                "404": {
                    "title": "Fehler",
                    "message": "Der Inhalt konnte aufgrund eines Fehlers nicht geladen werden."
                }
            },
            "general": {
                "title": "Fehler",
                "message": "Während der Verarbeitung ist ein unbekannter Fehler aufgetreten."
            }
        },
        "login": {
            "required": "Für den Zugriff auf die angeforderte Seite müssen Sie sich anmelden. Bitte geben Sie Ihre Anmeldedaten ein."
        },
        "showPassword": "Passwort anzeigen",
        "hidePassword": "Passwort verbergen",
        "passwordStrength": "Passwortstärke",
        "passwordStrengthEvaluation": {
            "worst": "Schwach",
            "bad": "Schlecht",
            "weak": "Mittel",
            "good": "Gut",
            "strong": "Stark"
        },
        "mimeTypes": {
            "application": "Anwendungspezifisch",
            "application/pdf": "PDF Dokument",
            "application/msword": "MS Word Dokument",
            "application/msexcel": "MS Excel Dokument",
            "application/mspowerpoint": "MS Powerpoint",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "MS Word Dokument",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "MS Excel Dokument",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation": "MS Powerpoint",
            "application/vnd.oasis.opendocument.text": "Open Dokument Text",
            "application/vnd.oasis.opendocument.spreadsheet": "Open Dokument Tabellenkalkulation",
            "application/vnd.oasis.opendocument.presentation": "Open Dokument Präsentation",
            "application/vnd.oasis.opendocument.chart": "Open Dokument Chart",
            "application/vnd.oasis.opendocument.formula": "Open Dokument Formel",
            "image": "Bild",
            "image/jpg": "JPG Bild",
            "image/jpeg": "JPG Bild",
            "image/gif": "GIF Bild",
            "image/png": "PNG Bild",
            "image/tiff": "TIFF Bild",
            "image/bmp": "Bitmap Bild",
            "video": "Video",
            "video/mp4": "MP4 Video",
            "video/mpg": "MPG Video",
            "audio": "Audio",
            "audio/wav": "WAV Audio",
            "audio/mp3": "MP3 Audio",
            "audio/ogg": "OGG Audio"
        },
        "validationError": {
            "title": "Formulareingaben unvollständig",
            "message": "Das Formular enthält unvollständige oder fehlerhafte Einträge. Bitte überprüfen Sie die rot markierten Felder auf Richtigkeit."
        },
        "validator": {
            "passwordVerification": {
                "notvalid": "Das Bestätigungspasswort muss mit dem Passwort übereinstimmen."
            },
            "selectionRequired": {
                "notvalid": "Bitte nehmen Sie eine Auswahl vor."
            },
            "equals": {
                "notvalid": "Der eingegebene Wert «{{source}}» stimmt nicht mit «{{dest}}» überein."
            },
            "notEmpty": {
                "null": "Dieses Feld darf nicht leer sein.",
                "notvalid": "Dieses Feld darf nicht leer sein."
            },
            "string": {
                "notvalid": "Es wird eine gültige Zeichenkette erwartet."
            },
            "stringLength": {
                "between": "Die Länge der angegebenen Zeichenkette liegt nicht zwischen {{min}} und {{max}} Zeichen.",
                "less": "Die Länge der angegebenen Zeichenkette ist kürzer als {{min}} Zeichen.",
                "exceed": "Die Länge der angegebenen Zeichenkette übersteigt {{max}} Zeichen.",
                "pasteOverflow": "Die Länge des einzufügenden Inhaltes übersteigt die erlaubten {{max}} Zeichen."
            },
            "emailAddress": {
                "notvalid": "Der eingegebene Wert ist keine gültige E-Mail Adresse."
            },
            "integer": {
                "notvalid": "Der eingegebene Wert ist keine gültige Ganzzahl."
            },
            "float": {
                "notvalid": "Der eingegebene Wert ist keine gültige Gleitkommazahl."
            },
            "numbersOnly": {
                "notvalid": "Der angegebene Wert darf nur Zahlen enthalten."
            },
            "numberRange": {
                "notvalid": "Der angegebene Wert ist keine gültige Zahl.",
                "range": "Der angegebene Wert ist nicht im Bereich von {{min}} bis {{max}}."
            },
            "boolean": {
                "nottrue": "Der angegebene Wert ist nicht WAHR.",
                "notfalse": "Der angegebene Wert ist nicht FALSCH."
            },
            "file": {
                "notaccepted": "Es sind nur Dateien des folgenden Typs erlaubt: {{allowed}}.",
                "wrongsize": "Die Größe der ausgewählten Datei(en) übersteigt die erlaubte Größe von {{max}}."
            },
            "regularExpression": {
                "empty": "Der reguläre Ausdruck ist leer.",
                "nomatch": "Der angegebene Wert stimmt nicht mit dem Muster überein.",
                "error": "Der reguläre Ausdruck «{{pattern}}» enthält einen Fehler."
            },
            "yourInput": "Ihre Eingabe"
        },
        "confirm": {
            "delete": "Möchten Sie wirklich diesen Eintrag löschen?"
        },
        "consent": {
            "info": "An dieser Stelle präsentieren wir Ihnen Inhalt eines externen Anbieters. Damit Sie diesen Inhalt sehen können, müssen Sie dem Einsatz von Cookies zustimmen.",
            "optoutInfo": "Ich bin damit einverstanden, dass mir externe Inhalte angezeigt werden. Damit können personenbezogene Daten an Drittplattformen übermittelt werden. Sie können dieser Zustimmung jederzeit in Ihren Cookie-Einstellungen widerrufen. Mehr dazu in unserer <a href=\"/service/datenschutz\" target=\"_blank\">Datenschutzerklärung</a>.",
            "vendor": "Anbieter",
            "confirmAction": "Zustimmung erteilen und den Inhalt anzeigen",
            "optoutAction": "Zustimmung verweigern und externen Inhalt nicht mehr anzeigen"
        }
    }
});

bundles.push({
    lang: 'de',
    namespace: 'photoswipe',
    resources: {
        "closeTitle": "schließen",
        "zoomTitle": "vergrößern",
        "arrowPrevTitle": "vorheriges Bild",
        "arrowNextTitle": "nächstes Bild",
        "indexIndicatorSep": " von ",
        "errorMsg": 'Das Foto konnte aufgrund eines Fehlers nicht geladen werden'
    }
});

bundles.push({
    lang: 'de',
    namespace: 'accessibility',
    resources: {
        "info": "Hier können Sie verschiedene Einstellungen für ein optimales Darstellungsbild und besserer Zugänglichkeit vornehmen.",
        "group": {
            "typeface": "Schriftbild",
            "colorFilter": "Farbfilter",
            "theme": "Thema"
        },
        "control": {
            "fontSize": "Schriftgröße",
            "grayscale": "Graustufen",
            "blueLightFilter": "Blaulichtfilter",
            "brightness": "Helligkeit",
            "moreContrast": "Mehr Kontrast",
            "darkmode": "Dunkler Modus"
        },
        "action": {
            "bigger": "Schriftgröße größer",
            "smaller": "Schriftgröße kleiner",
            "resetSettings": "Einstellungen zurücksetzen"
        },
        "sizes": {
            "normal": "Normal",
            "middle": "Mittel",
            "max": "Maximal"
        }
    }
});

export default bundles;
